export function waitForHubSpotForms() {
  const observer = new MutationObserver((mutations, obs) => {
    const modals = document.querySelectorAll(".modal-box:has(.embedded form)");
    if (modals.length > 0) {
      modals.forEach((modal) => {
        if (!modal.dataset.hubspotReady) {
          modal.dataset.hubspotReady = "true";
          const submitButton = modal.querySelector(".hs-button[type=submit]");
          const ctaButton = document.querySelector(`[data-target=${modal.id}]`);
          const form = modal.querySelector("form");
          form.addEventListener("submit", (ev) => {
            const consentTypes =
              window.CookieInformation.getStatusOfUsedConsentTypes();
            const consent = consentTypes.cookie_cat_marketing;
            if (!consent) {
              console.log("Consent not given");
            }
            const countrySelect = modal.querySelector(".hs_nation select");
            const dataset = {
              event: "lead_submit",
              user_data: {
                firstName:
                  modal.querySelector(".hs_firstname input")?.value ?? "",
                lastName:
                  modal.querySelector(".hs_lastname input")?.value ?? "",
                phone: modal.querySelector(".hs_phone input")?.value ?? "",
                email: modal.querySelector(".hs_email input")?.value ?? "",
                country:
                  countrySelect.options[countrySelect.selectedIndex].text ?? "",
              },
              page: window.location.href,
              clicked_button: ctaButton.innerText,
              company_type:
                modal.querySelector(".hs_company_type input")?.value ?? "",
              job_title:
                modal.querySelector(".hs_job_title select")?.value ?? "",
            };
            window.dataLayer.push(dataset);
          });
        }
      });
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}
